"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.identifyConsumer = exports.configureTracking = exports.getAnalytics = void 0;
var analytics_js_loader_1 = __importDefault(require("analytics.js-loader"));
var lodash_get_1 = __importDefault(require("lodash.get"));
var queryString = __importStar(require("query-string"));
var constants_1 = __importDefault(require("./constants"));
var enums_1 = require("./enums");
var simpleStore_1 = require("./simpleStore");
var consumerIdentified = false;
exports.getAnalytics = function () {
    return window.analytics;
};
exports.configureTracking = function (experience) {
    if (!exports.getAnalytics()) {
        analytics_js_loader_1["default"]({
            writeKey: experience === enums_1.Experience.Caviar
                ? constants_1["default"].segmentCaviarApiKey
                : constants_1["default"].segmentDDApiKey
        });
    }
};
/**
 * Retrieve all the DoorDash Common Fields from the browser cookies
 * and return them as an object.
 *
 * Common Fields are created by the backend and set as
 * cookies starting with 'dd_'.
 *
 * @returns {object} key-value representation of all
 * current common fields cookies
 */
var DD_COMMON_FIELDS = [
    'dd_login_id',
    'dd_district_id',
    'dd_zip_code',
    'dd_device_id',
    'dd_session_id',
    'dd_submarket_id',
    'dd_guest_id',
];
var getCommonFields = function () {
    return DD_COMMON_FIELDS.reduce(function (commonFields, fieldName) {
        var _a;
        return (__assign(__assign({}, commonFields), (_a = {}, _a[fieldName] = simpleStore_1.readCookie(fieldName), _a)));
    }, {});
};
var getBrowserData = function () {
    var hasTouchEvents = window ? 'ontouchstart' in window : false;
    var innerWidth = lodash_get_1["default"](window, 'innerWidth') || 0;
    var innerHeight = lodash_get_1["default"](window, 'innerHeight') || 0;
    var userAgent = lodash_get_1["default"](window, 'navigator.userAgent') || 0;
    return {
        href: lodash_get_1["default"](window, 'location.href') || '',
        referrer: lodash_get_1["default"](window, 'document.referrer') || '',
        platform: hasTouchEvents && innerWidth < 900 ? 'mobile' : 'desktop',
        browser_width: innerWidth,
        browser_height: innerHeight,
        touch: hasTouchEvents,
        user_agent: userAgent
    };
};
var getUtmFields = function () {
    try {
        var queryParams = queryString.parse(window.location.search) || {};
        return {
            utmCampaign: queryParams.utm_campaign,
            utmSource: queryParams.utm_source,
            utmMedium: queryParams.utm_medium
        };
    }
    catch (err) {
        return {};
    }
};
exports.identifyConsumer = function (consumerId) {
    if (exports.getAnalytics() && !consumerIdentified) {
        consumerIdentified = true;
        exports.getAnalytics().identify(consumerId);
    }
};
// Track and store custom event using Segment as destination.
// Check Segment configuration for more details:
// https://app.segment.com/doordash/sources/consumer_web/overview
var track = function (eventName, body, context) {
    if (body === void 0) { body = {}; }
    var payload = __assign(__assign(__assign(__assign({}, body), getBrowserData()), getCommonFields()), getUtmFields());
    if (exports.getAnalytics()) {
        exports.getAnalytics().track(eventName, payload, context);
    }
};
exports["default"] = track;
